"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var react_2 = require("@emotion/react");

var rgba_1 = __importDefault(require("polished/lib/color/rgba"));

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_button_1 = require("@ryerson/frontend.button");

var frontend_common_1 = require("@ryerson/frontend.common");

var HeaderConfig_1 = require("../common/HeaderConfig/HeaderConfig");

var frontend_application_1 = require("@ryerson/frontend.application");

var Constants_1 = require("../common/Constants");

var productMenuContent_1 = require("../ProductMenu/productMenuContent");

var NavigationHeader = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\theight: 50px;\n\tdisplay: block;\n\tposition: relative;\n\twidth: 100%;\n\tz-index: 99;\n\t", "\n"])), function (props) {
  var theme = props.theme;
  return (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tborder-bottom: 1px solid ", ";\n\t\t\tbackground-color: ", ";\n\t\t"])), (0, rgba_1.default)(theme.colors.primary.lighterGray, 0.1), theme.colors.primary.darkGray);
});
var NavigationBody = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tdisplay: block;\n\theight: calc(100% - 50px);\n\toverflow-x: hidden;\n\toverflow-y: hidden;\n\twidth: 100%;\n\tposition: relative;\n\tbox-sizing: border-box;\n"])));
var NavigationSlide = styled_1.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tdisplay: block;\n\tposition: absolute;\n\ttop: 0px;\n\theight: calc(100% - 50px);\n\twidth: 100%;\n\tpadding: 25px 0px 0px 0px;\n\ttransition: left 0.3s ease-in;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n"])));
var Divider = styled_1.default.hr(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tdisplay: block;\n\twidth: 100%;\n\tmargin-top: 1px;\n\tmargin-bottom: 1px;\n"])));
var Spacer = styled_1.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\tdisplay: block;\n\twidth: 100%;\n\theight: 10px;\n"])));
var HSpacer = styled_1.default.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\tpadding-right: 10px;\n\tmin-width: 85px;\n\tdisplay: inline-block;\n"])));

var closeMenu = function closeMenu(props) {
  var theme = props.theme;
  return (0, react_2.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\theight: 50px;\n\t\twidth: 50px;\n\t\tborder-left: 1px solid ", ";\n\t"])), (0, rgba_1.default)(theme.colors.primary.lighterGray, 0.1));
};

var HamburgerMenu = function HamburgerMenu(_ref) {
  var globalMenus = _ref.globalMenus,
      productMenus = _ref.productMenus,
      locations = _ref.locations,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      companyName = _ref.companyName;

  var _ref2 = (0, react_1.useState)(function () {
    var currVal = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.hamburgerActive);
    return currVal === "true" ? true : false;
  }),
      _ref3 = _slicedToArray(_ref2, 2),
      menuActive = _ref3[0],
      setMenuActive = _ref3[1];

  var _ref4 = (0, frontend_application_1.useApplication)(),
      _ref4$localization = _ref4.localization,
      country = _ref4$localization.country,
      language = _ref4$localization.language;

  var content = productMenuContent_1.ProductMenuContent[language] || productMenuContent_1.ProductMenuContent.en;

  var buttonLinkPath = function buttonLinkPath() {
    var _a;

    return (_a = Constants_1.productPaths.find(function (productItem) {
      return productItem.contentful_id === (productLine === null || productLine === void 0 ? void 0 : productLine.contentful_id);
    })) === null || _a === void 0 ? void 0 : _a.url;
  };

  var _ref5 = (0, frontend_theme_1.useTheme)(),
      theme = _ref5.theme;

  var _ref6 = (0, react_1.useState)(""),
      _ref7 = _slicedToArray(_ref6, 2),
      bodyStyles = _ref7[0],
      setBodyStyles = _ref7[1];

  var _react_1$default$useS = react_1.default.useState(productMenus[0]),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      productLine = _react_1$default$useS2[0],
      setProductLine = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(globalMenus[0]),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      globalMenu = _react_1$default$useS4[0],
      setGlobalMenu = _react_1$default$useS4[1];

  var _react_1$default$useS5 = react_1.default.useState("home"),
      _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
      currentMenu = _react_1$default$useS6[0],
      setCurrentMenu = _react_1$default$useS6[1];

  var headerSettings = HeaderConfig_1.headerConfigData[companyName];
  var _headerSettings$utili = headerSettings.utilityMenus,
      showLanguage = _headerSettings$utili.showLanguage,
      showCountry = _headerSettings$utili.showCountry,
      showLocation = _headerSettings$utili.showLocation;
  var mainContainerStyles = {
    left: "".concat(menuActive ? "0%" : "-100%"),
    width: "100%",
    top: "-50px",
    transition: "left 0.3s linear",
    height: "100vh",
    maxHeight: "100vh",
    backgroundColor: "".concat(theme.colors.primary.darkGray),
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    zIndex: 999
  };
  var languageCountryLocationCategories = {
    language: {
      id: "language",
      key: language,
      display: frontend_application_1.LanguageDisplay,
      values: frontend_application_1.Language,
      title: "Language"
    },
    country: {
      id: "country",
      key: country,
      display: frontend_application_1.CountryDisplay,
      values: frontend_application_1.Country,
      title: "Country"
    },
    locations: {
      id: "location",
      key: "",
      display: locations,
      values: locations,
      title: "Locations"
    }
  };
  (0, react_1.useEffect)(function () {
    var body = document === null || document === void 0 ? void 0 : document.querySelector("body");

    if (active === true) {
      setMenuActive(true);
      setBodyStyles((body === null || body === void 0 ? void 0 : body.getAttribute("style")) || "");
      body && body.setAttribute("style", "overflow: hidden;");
      sessionStorage.setItem(frontend_common_1.SessionItems.hamburgerActive, "true");
    } else {
      setMenuActive(false);
      body && body.setAttribute("style", bodyStyles);
      sessionStorage.setItem(frontend_common_1.SessionItems.hamburgerActive, "false");
    }
  }, [active]);

  var handleClose = function handleClose(params) {
    var _ref8 = params || {},
        url = _ref8.url,
        country = _ref8.country,
        language = _ref8.language;

    setMenuActive(false);

    if (url || country || language) {
      onClose({
        url: url,
        country: country,
        language: language
      });
      setTimeout(function () {
        setCurrentMenu("home");
      }, 500);
    } else {
      setTimeout(function () {
        setCurrentMenu("home");
        onClose({
          url: url,
          country: country,
          language: language
        });
      }, 500);
    }

    sessionStorage.setItem(frontend_common_1.SessionItems.hamburgerActive, "false");
  };

  var handleBack = function handleBack() {
    if (currentMenu.includes("product_line")) {
      setCurrentMenu("buy_metal");
    }

    if (currentMenu === "location" || currentMenu === "language" || currentMenu === "country" || currentMenu === "global_menu" || currentMenu === "buy_metal") {
      setCurrentMenu("home");
    }
  };

  return (0, jsx_runtime_1.jsxs)("div", {
    style: mainContainerStyles,
    children: [(0, jsx_runtime_1.jsx)(NavigationHeader, {
      theme: theme,
      children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        alignItems: "center",
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          grow: 1,
          children: currentMenu !== "home" && (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
            justifyContent: "flex-start",
            onClick: function onClick() {
              handleBack();
            },
            children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
              alignSelf: "center",
              children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
                shape: "circle",
                rightIcon: "chevron-left",
                size: "xs",
                label: " ",
                variant: "outline",
                onClick: function onClick() {
                  handleBack();
                },
                foreground: "light",
                background: theme.colors.primary.gray
              })
            }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
              alignSelf: "center",
              css: (0, react_2.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\tpadding-left: 10px;\n\t\t\t\t\t\t\t\t\t"]))),
              children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                variant: "p",
                color: theme.colors.tertiary.label,
                children: "Back"
              })
            })]
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
            style: closeMenu({
              theme: theme
            }),
            justifyContent: "center",
            alignItems: "center",
            children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
              icon: "close",
              size: "sm",
              onClick: function onClick() {
                return handleClose();
              },
              color: theme.colors.primary.white
            })
          })
        })]
      })
    }), (0, jsx_runtime_1.jsxs)(NavigationBody, {
      children: [(0, jsx_runtime_1.jsx)(NavigationSlide, {
        css: (0, react_2.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tleft: ", ";\n\t\t\t\t\t"])), currentMenu === "home" ? "0px" : "-110%"),
        children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          direction: "column",
          css: (0, react_2.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t"]))),
          children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
            children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
              direction: "column",
              justifyContent: "flex-start",
              css: (0, react_2.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\tpadding-left: 20px;\n\t\t\t\t\t\t\t\t\tpadding-right: 20px;\n\t\t\t\t\t\t\t\t"]))),
              children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                css: (0, react_2.css)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t"]))),
                children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                  direction: "row",
                  justifyContent: "space-between",
                  onClick: function onClick() {
                    setCurrentMenu("buy_metal");
                  },
                  children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                      variant: "div",
                      size: "lg",
                      color: theme.colors.primary.white,
                      children: "Buy Metal"
                    })
                  }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                      size: "xs",
                      icon: "chevron-right",
                      color: theme.colors.primary.white
                    })
                  })]
                })
              }), (0, jsx_runtime_1.jsx)(Divider, {
                css: (0, react_2.css)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\topacity: 0.1;\n\t\t\t\t\t\t\t\t\t"])))
              }), globalMenus.map(function (menu, index) {
                return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
                  children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    css: (0, react_2.css)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t\t\t\t"]))),
                    children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                      direction: "row",
                      justifyContent: "space-between",
                      onClick: function onClick() {
                        setCurrentMenu("global_menu");
                        setGlobalMenu(menu);
                      },
                      children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                        children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                          variant: "div",
                          size: "lg",
                          color: theme.colors.primary.white,
                          children: menu.label
                        })
                      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                        children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                          size: "xs",
                          icon: "chevron-right",
                          color: theme.colors.primary.white
                        })
                      })]
                    })
                  }), (0, jsx_runtime_1.jsx)(Divider, {
                    css: (0, react_2.css)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\topacity: 0.1;\n\t\t\t\t\t\t\t\t\t\t\t\t"])))
                  })]
                }, index);
              }), headerSettings.globalMenus.showStockList && (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {
                children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                  css: (0, react_2.css)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t\t\t"]))),
                  children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                    direction: "row",
                    justifyContent: "space-between",
                    onClick: function onClick() {
                      handleClose({
                        url: "/stock-list"
                      });
                    },
                    children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                      children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                        variant: "div",
                        size: "lg",
                        color: theme.colors.primary.white,
                        children: "Get Stock List"
                      })
                    })
                  })
                })
              })]
            }), (0, jsx_runtime_1.jsx)(Spacer, {
              css: (0, react_2.css)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\theight: 25px;\n\t\t\t\t\t\t\t\t"])))
            })]
          }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
            grow: 1,
            css: (0, react_2.css)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\tbackground-color: ", ";\n\t\t\t\t\t\t\t"])), theme.colors.primary.darkerGray),
            children: [(0, jsx_runtime_1.jsx)(Spacer, {
              css: (0, react_2.css)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\theight: 25px;\n\t\t\t\t\t\t\t\t"])))
            }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
              direction: "column",
              justifyContent: "flex-start",
              css: (0, react_2.css)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\tpadding-left: 20px;\n\t\t\t\t\t\t\t\t\tpadding-right: 20px;\n\t\t\t\t\t\t\t\t"]))),
              children: [showLanguage && (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
                children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                  justifyContent: "space-between",
                  alignItems: "center",
                  onClick: function onClick() {
                    return setCurrentMenu("language");
                  },
                  children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    css: (0, react_2.css)(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t\t\t\t"]))),
                    children: (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                      type: "tertiary",
                      size: "md",
                      children: [(0, jsx_runtime_1.jsx)(HSpacer, {
                        children: "Language:"
                      }), " ", Object.keys(frontend_application_1.Language).map(function (item) {
                        return item === language ? (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                          type: "tertiary",
                          children: [" ", frontend_application_1.LanguageDisplay[item]]
                        }, item) : null;
                      })]
                    })
                  }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                      justifyContent: "center",
                      alignItems: "center",
                      children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                        icon: "chevron-right",
                        size: "xs",
                        color: theme.colors.primary.white
                      })
                    })
                  })]
                }), (0, jsx_runtime_1.jsx)(Divider, {
                  css: (0, react_2.css)(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\topacity: 0.1;\n\t\t\t\t\t\t\t\t\t\t\t"])))
                })]
              }), showCountry && (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
                children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                  justifyContent: "space-between",
                  alignItems: "center",
                  onClick: function onClick() {
                    return setCurrentMenu("country");
                  },
                  children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    css: (0, react_2.css)(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t\t\t\t"]))),
                    children: (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                      type: "tertiary",
                      size: "md",
                      children: [(0, jsx_runtime_1.jsx)(HSpacer, {
                        children: "Country:"
                      }), Object.keys(frontend_application_1.Country).map(function (item) {
                        return item === country ? (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                          type: "tertiary",
                          children: [" ", frontend_application_1.CountryDisplay[item]]
                        }, item) : null;
                      })]
                    })
                  }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                      justifyContent: "center",
                      alignItems: "center",
                      children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                        icon: "chevron-right",
                        size: "xs",
                        color: theme.colors.primary.white
                      })
                    })
                  })]
                }), (0, jsx_runtime_1.jsx)(Divider, {
                  css: (0, react_2.css)(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\topacity: 0.1;\n\t\t\t\t\t\t\t\t\t\t\t"])))
                })]
              }), showLocation && (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                justifyContent: "space-between",
                alignItems: "center",
                onClick: function onClick() {
                  return setCurrentMenu("location");
                },
                children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                  css: (0, react_2.css)(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t\t\t"]))),
                  children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                    type: "tertiary",
                    size: "md",
                    children: "Locations"
                  })
                }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                  children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                    justifyContent: "center",
                    alignItems: "center",
                    children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                      icon: "chevron-right",
                      size: "xs",
                      color: theme.colors.primary.white
                    })
                  })
                })]
              })]
            })]
          })]
        })
      }), (0, jsx_runtime_1.jsxs)(NavigationSlide, {
        css: (0, react_2.css)(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tleft: ", ";\n\t\t\t\t\t"])), currentMenu === "global_menu" ? "0px" : "110%"),
        children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          variant: "h2",
          color: theme.colors.primary.white,
          weight: "bolder",
          css: (0, react_2.css)(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t\t\t\tmargin-left: 20px;\n\t\t\t\t\t\t"]))),
          children: globalMenu.label
        }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          direction: "column",
          justifyContent: "flex-start",
          css: (0, react_2.css)(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpadding-left: 20px;\n\t\t\t\t\t\t\tpadding-right: 20px;\n\t\t\t\t\t\t"]))),
          children: [globalMenu.column1Links && globalMenu.column1Links.length > 0 && globalMenu.column1Links.map(function (link, index) {
            return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
              children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                onClick: function onClick() {
                  handleClose({
                    url: link.url
                  });
                },
                css: (0, react_2.css)(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t\t\t"]))),
                children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  direction: "row",
                  justifyContent: "space-between",
                  children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                      variant: "div",
                      size: index === 0 ? "lg" : "md",
                      color: theme.colors.primary.white,
                      children: link.label
                    })
                  })
                })
              }, index), globalMenu.column1Links.length - 1 !== index ? index === 0 ? (0, jsx_runtime_1.jsx)(Divider, {
                css: (0, react_2.css)(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\t\topacity: 0.5;\n\t\t\t\t\t\t\t\t\t\t\t\t\t"])))
              }) : (0, jsx_runtime_1.jsx)(Divider, {
                css: (0, react_2.css)(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\t\topacity: 0.1;\n\t\t\t\t\t\t\t\t\t\t\t\t\t"])))
              }) : (0, jsx_runtime_1.jsx)(Spacer, {
                css: (0, react_2.css)(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\theight: 20px;\n\t\t\t\t\t\t\t\t\t\t\t\t"])))
              })]
            }, index);
          }), globalMenu.column2Links && globalMenu.column2Links.length > 0 && globalMenu.column2Links.map(function (link, index) {
            return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
              children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                onClick: function onClick() {
                  handleClose({
                    url: link.url
                  });
                },
                css: (0, react_2.css)(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t\t\t"]))),
                children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  direction: "row",
                  justifyContent: "space-between",
                  children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                      variant: "div",
                      size: index === 0 ? "lg" : "md",
                      color: theme.colors.primary.white,
                      children: link.label
                    })
                  })
                })
              }, index), globalMenu.column2Links.length - 1 !== index ? index === 0 ? (0, jsx_runtime_1.jsx)(Divider, {
                css: (0, react_2.css)(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\t\topacity: 0.5;\n\t\t\t\t\t\t\t\t\t\t\t\t\t"])))
              }) : (0, jsx_runtime_1.jsx)(Divider, {
                css: (0, react_2.css)(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\t\topacity: 0.1;\n\t\t\t\t\t\t\t\t\t\t\t\t\t"])))
              }) : (0, jsx_runtime_1.jsx)(Spacer, {
                css: (0, react_2.css)(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\theight: 20px;\n\t\t\t\t\t\t\t\t\t\t\t\t"])))
              })]
            }, index);
          }), globalMenu.column3Links && globalMenu.column3Links.length > 0 && globalMenu.column3Links.map(function (link, index) {
            return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
              children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                onClick: function onClick() {
                  handleClose({
                    url: link.url
                  });
                },
                css: (0, react_2.css)(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t\t\t"]))),
                children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  direction: "row",
                  justifyContent: "space-between",
                  children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                      variant: "div",
                      size: index === 0 ? "lg" : "md",
                      color: theme.colors.primary.white,
                      children: link.label
                    })
                  })
                })
              }, index), globalMenu.column3Links.length - 1 !== index ? index === 0 ? (0, jsx_runtime_1.jsx)(Divider, {
                css: (0, react_2.css)(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\t\topacity: 0.5;\n\t\t\t\t\t\t\t\t\t\t\t\t\t"])))
              }) : (0, jsx_runtime_1.jsx)(Divider, {
                css: (0, react_2.css)(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\t\topacity: 0.1;\n\t\t\t\t\t\t\t\t\t\t\t\t\t"])))
              }) : (0, jsx_runtime_1.jsx)(Spacer, {
                css: (0, react_2.css)(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\theight: 20px;\n\t\t\t\t\t\t\t\t\t\t\t\t"])))
              })]
            }, index);
          })]
        }), (0, jsx_runtime_1.jsx)(Spacer, {
          css: (0, react_2.css)(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\theight: 20px;\n\t\t\t\t\t\t"])))
        })]
      }), (0, jsx_runtime_1.jsxs)(NavigationSlide, {
        css: (0, react_2.css)(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tleft: ", ";\n\t\t\t\t\t"])), currentMenu === "buy_metal" ? "0px" : currentMenu.includes("product_line") ? "-110%" : "110%"),
        children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          variant: "h2",
          color: theme.colors.primary.white,
          weight: "bolder",
          css: (0, react_2.css)(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t\t\t\tmargin-left: 20px;\n\t\t\t\t\t\t"]))),
          children: "Buy Metal"
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          direction: "column",
          justifyContent: "flex-start",
          css: (0, react_2.css)(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpadding-left: 20px;\n\t\t\t\t\t\t\tpadding-right: 20px;\n\t\t\t\t\t\t"]))),
          children: productMenus.map(function (productLine, index) {
            return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
              children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                css: (0, react_2.css)(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t\t"]))),
                children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                  direction: "row",
                  justifyContent: "space-between",
                  onClick: function onClick() {
                    setCurrentMenu("product_line_" + productLine.contentful_id);
                    setProductLine(productLine);
                  },
                  children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                      variant: "div",
                      size: "lg",
                      color: theme.colors.primary.white,
                      children: productLine.label
                    })
                  }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                      size: "xs",
                      icon: "chevron-right",
                      color: theme.colors.primary.white
                    })
                  })]
                })
              }, index), productMenus.length - 1 !== index && (0, jsx_runtime_1.jsx)(Divider, {
                css: (0, react_2.css)(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\topacity: 0.1;\n\t\t\t\t\t\t\t\t\t\t\t"])))
              })]
            }, index);
          })
        })]
      }), (0, jsx_runtime_1.jsxs)(NavigationSlide, {
        css: (0, react_2.css)(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tleft: ", ";\n\t\t\t\t\t"])), currentMenu.includes("product_line") ? "0px" : "110%"),
        children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          variant: "h2",
          weight: "bolder",
          color: theme.colors.primary.white,
          css: (0, react_2.css)(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t\t\t\tmargin-left: 20px;\n\t\t\t\t\t\t"]))),
          children: productLine.label
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          direction: "column",
          justifyContent: "flex-start",
          css: (0, react_2.css)(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpadding-left: 20px;\n\t\t\t\t\t\t\tpadding-right: 20px;\n\t\t\t\t\t\t"]))),
          children: productLine.megaMenuProductGroups.map(function (productGroup, index) {
            return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
              children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                css: (0, react_2.css)(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t\t\t"]))),
                children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  direction: "row",
                  justifyContent: "space-between",
                  children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                      variant: "div",
                      size: "lg",
                      color: theme.colors.primary.lightGray,
                      children: productGroup.label
                    })
                  })
                })
              }), (0, jsx_runtime_1.jsx)(Divider, {
                css: (0, react_2.css)(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\topacity: 0.5;\n\t\t\t\t\t\t\t\t\t\t\t"])))
              }), productGroup.megaMenuLinks.map(function (link, linkIndex) {
                return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
                  children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    onClick: function onClick() {
                      handleClose({
                        url: link.url
                      });
                    },
                    css: (0, react_2.css)(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"]))),
                    children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                      direction: "row",
                      justifyContent: "flex-start",
                      children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                        css: (0, react_2.css)(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tpadding-right: 10px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"]))),
                        children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                          icon: link.icon,
                          color: theme.colors.primary.lightGray,
                          size: "sm"
                        })
                      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                        children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                          variant: "div",
                          size: "md",
                          color: theme.colors.primary.white,
                          children: link.label
                        })
                      })]
                    })
                  }), productGroup.megaMenuLinks.length - 1 !== linkIndex ? (0, jsx_runtime_1.jsx)(Divider, {
                    css: (0, react_2.css)(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\topacity: 0.1;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"])))
                  }) : (0, jsx_runtime_1.jsx)(Spacer, {})]
                }, linkIndex);
              })]
            }, index);
          })
        }), (0, jsx_runtime_1.jsx)(Divider, {
          css: (0, react_2.css)(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tmargin-top: 20px;\n\t\t\t\t\t\t\topacity: 0.1;\n\t\t\t\t\t\t\tmargin-bottom: 30px;\n\t\t\t\t\t\t\twidth: calc(100% - 40px);\n\t\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t\t\tmargin-right: auto;\n\t\t\t\t\t\t"])))
        }), (0, jsx_runtime_1.jsx)(Spacer, {
          css: (0, react_2.css)(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\theight: auto;\n\t\t\t\t\t\t\tmargin-bottom: 30px;\n\t\t\t\t\t\t\tpadding-left: 20px;\n\t\t\t\t\t\t\tbox-sizing: border-box;\n\t\t\t\t\t\t"]))),
          children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.ButtonLink, {
            to: "".concat(buttonLinkPath()),
            gatsby: false,
            linkType: "internal",
            type: "tertiary",
            size: "sm",
            label: [content.metalHelpText1, content.metalHelpText2]
          })
        })]
      }), (0, jsx_runtime_1.jsxs)(NavigationSlide, {
        css: (0, react_2.css)(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tleft: ", ";\n\t\t\t\t\t\tbackground-color: ", ";\n\t\t\t\t\t"])), currentMenu === "language" ? "0px" : "110%", theme.colors.secondary.background),
        children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          variant: "h2",
          type: "secondary",
          weight: "bolder",
          css: (0, react_2.css)(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t\t\t\tmargin-left: 20px;\n\t\t\t\t\t\t"]))),
          children: "Language"
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          direction: "column",
          justifyContent: "flex-start",
          css: (0, react_2.css)(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpadding-left: 20px;\n\t\t\t\t\t\t\tpadding-right: 20px;\n\t\t\t\t\t\t"]))),
          children: Object.keys(languageCountryLocationCategories.language.display).map(function (languageItem, index) {
            return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
              children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                css: (0, react_2.css)(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t\t\t"]))),
                children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                  direction: "row",
                  justifyContent: "space-between",
                  onClick: function onClick() {
                    handleClose({
                      language: languageCountryLocationCategories.language.values[languageItem]
                    });
                  },
                  children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                      variant: "div",
                      size: "md",
                      type: "secondary",
                      color: language === languageCountryLocationCategories.language.values[languageItem] ? theme.colors.primary.header : theme.colors.primary.primaryBrand,
                      children: languageCountryLocationCategories.language.display[languageItem]
                    })
                  }), language === languageCountryLocationCategories.language.values[languageItem] && (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                      size: "xs",
                      icon: "check",
                      color: theme.colors.primary.header
                    })
                  })]
                })
              }, index), Object.keys(languageCountryLocationCategories.language.display).length - 1 !== index && (0, jsx_runtime_1.jsx)(Divider, {
                css: (0, react_2.css)(_templateObject62 || (_templateObject62 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\topacity: 0.1;\n\t\t\t\t\t\t\t\t\t\t\t\t"])))
              })]
            }, index);
          })
        })]
      }), (0, jsx_runtime_1.jsxs)(NavigationSlide, {
        css: (0, react_2.css)(_templateObject63 || (_templateObject63 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tleft: ", ";\n\t\t\t\t\t\tbackground-color: ", ";\n\t\t\t\t\t"])), currentMenu === "country" ? "0px" : "110%", theme.colors.secondary.background),
        children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          variant: "h2",
          type: "secondary",
          weight: "bolder",
          css: (0, react_2.css)(_templateObject64 || (_templateObject64 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t\t\t\tmargin-left: 20px;\n\t\t\t\t\t\t"]))),
          children: "Country"
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          direction: "column",
          justifyContent: "flex-start",
          css: (0, react_2.css)(_templateObject65 || (_templateObject65 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpadding-left: 20px;\n\t\t\t\t\t\t\tpadding-right: 20px;\n\t\t\t\t\t\t"]))),
          children: Object.keys(languageCountryLocationCategories.country.display).map(function (countryItem, index) {
            return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
              children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                css: (0, react_2.css)(_templateObject66 || (_templateObject66 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t\t\t"]))),
                children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                  direction: "row",
                  justifyContent: "space-between",
                  onClick: function onClick() {
                    if (countryItem !== "cn") {
                      handleClose({
                        country: languageCountryLocationCategories.country.values[countryItem]
                      });
                    }
                  },
                  children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    children: (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                      variant: "div",
                      size: "md",
                      type: "secondary",
                      color: country === languageCountryLocationCategories.country.values[countryItem] ? theme.colors.primary.header : theme.colors.primary.primaryBrand,
                      children: [languageCountryLocationCategories.country.display[countryItem], countryItem === "cn" && (0, jsx_runtime_1.jsx)("span", {
                        css: (0, react_2.css)(_templateObject67 || (_templateObject67 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\twidth: 20px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\theight: 20px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tbackground-color: ", ";\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tborder-radius: 20px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tvertical-align: middle;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tline-height: 23px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-left: 10px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"])), theme.colors.primary.primaryBrand),
                        children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                          icon: "arrow-up-right",
                          size: "xs",
                          color: theme.colors.primary.white
                        })
                      })]
                    })
                  }), country === languageCountryLocationCategories.country.values[countryItem] && (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                      size: "xs",
                      icon: "check",
                      color: theme.colors.primary.header
                    })
                  })]
                })
              }, index), Object.keys(languageCountryLocationCategories.country.display).length - 1 !== index && (0, jsx_runtime_1.jsx)(Divider, {
                css: (0, react_2.css)(_templateObject68 || (_templateObject68 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\topacity: 0.1;\n\t\t\t\t\t\t\t\t\t\t\t\t"])))
              })]
            }, index);
          })
        })]
      }), (0, jsx_runtime_1.jsxs)(NavigationSlide, {
        css: (0, react_2.css)(_templateObject69 || (_templateObject69 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tleft: ", ";\n\t\t\t\t\t\tbackground-color: ", ";\n\t\t\t\t\t"])), currentMenu === "location" ? "0px" : "110%", theme.colors.secondary.background),
        children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          variant: "h2",
          type: "secondary",
          weight: "bolder",
          css: (0, react_2.css)(_templateObject70 || (_templateObject70 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t\t\t\tmargin-left: 20px;\n\t\t\t\t\t\t"]))),
          children: "Locations"
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          direction: "column",
          justifyContent: "flex-start",
          css: (0, react_2.css)(_templateObject71 || (_templateObject71 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpadding-left: 20px;\n\t\t\t\t\t\t\tpadding-right: 20px;\n\t\t\t\t\t\t"]))),
          children: languageCountryLocationCategories.locations.display.map(function (locationItem, index) {
            return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
              children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                css: (0, react_2.css)(_templateObject72 || (_templateObject72 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t\t\t"]))),
                children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  direction: "row",
                  justifyContent: "space-between",
                  onClick: function onClick() {
                    handleClose({
                      url: "/locations/".concat(frontend_application_1.CountryUrl[country], "/").concat(locationItem.urlLabel)
                    });
                  },
                  children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                      variant: "div",
                      size: "md",
                      type: "secondary",
                      color: theme.colors.primary.primaryBrand,
                      children: locationItem.label
                    })
                  })
                })
              }, index), (0, jsx_runtime_1.jsx)(Divider, {
                css: (0, react_2.css)(_templateObject73 || (_templateObject73 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\topacity: 0.1;\n\t\t\t\t\t\t\t\t\t\t\t"])))
              }), languageCountryLocationCategories.locations.display.length - 1 === index && country !== "mx" && (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                css: (0, react_2.css)(_templateObject74 || (_templateObject74 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t"]))),
                children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  direction: "row",
                  justifyContent: "space-between",
                  onClick: function onClick() {
                    handleClose({
                      url: "/locations/".concat(frontend_application_1.CountryUrl[country])
                    });
                  },
                  children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                      variant: "div",
                      size: "md",
                      type: "secondary",
                      weight: "bold",
                      color: theme.colors.primary.primaryBrand,
                      children: "All Locations"
                    })
                  })
                })
              }, index)]
            }, index);
          })
        })]
      })]
    })]
  });
};

exports.default = HamburgerMenu;